module.exports = __webpack_public_path__ + "img/copyHover.640a93e0.svg";